import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const mapStateToProps = ({ loading }) => ({
  isLoading:
    loading['emailTemplate/getEmailTemplateHtml'] ||
    loading['emailTemplate/getEmailTemplateHisHtml'] ||
    loading['emailTemplate/getEmailTemplateById'],
})

const EmailTemplatePreviewDialog = ({
  dispatch,
  history,
  emailTempId,
  title,
  isLoading,
  ...props
}) => {
  const [extendResponse, setExtendResponse] = useState({})
  const [htmlContent, setHtmlContent] = useState()
  const { onClose } = props

  const { t } = useTranslation()

  useEffect(() => {
    if (emailTempId) {
      dispatch({
        type: history
          ? 'emailTemplate/getEmailTemplateHisHtml'
          : 'emailTemplate/getEmailTemplateHtml',
        payload: { emailTempId },
        successCallback: response => {
          const { senderName, senderAddress, subject, content } = response

          const parser = new DOMParser()
          const doc = parser.parseFromString(content, 'text/html')

          const anchors = doc.getElementsByTagName('a')

          for (let i = 0; i < anchors.length; i += 1) {
            anchors[i].setAttribute('target', '_blank')
          }

          setHtmlContent(doc.documentElement.innerHTML)
          setExtendResponse({ senderName, senderAddress, subject })
        },
      })
    }
  }, [dispatch, emailTempId, history])

  return (
    <Dialog {...props} fullWidth maxWidth="lg">
      <DialogTitle>{title}</DialogTitle>
      {isLoading && (
        <Grid item display="flex" justifyContent="center" alignItems="center" xs={12} my={2}>
          <CircularProgress />
        </Grid>
      )}
      {!isLoading && (
        <DialogContent>
          <Box sx={{ backgroundColor: '#ecf1f2', padding: 2, fontSize: 14 }}>
            <Grid item container spacing={1}>
              <Grid item xs={2}>
                <Typography variant="subtitle2" sx={{ color: '#555' }}>
                  {t('general.sender')}
                </Typography>
              </Grid>
              <Grid item>
                <Box display="flex" alignItems="flex-end">
                  {extendResponse?.senderName}
                  <Typography ml={1} variant="caption" sx={{ color: '#555' }}>
                    {`<${extendResponse?.senderAddress}>`}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid item container spacing={1} mt={0}>
              <Grid item xs={2}>
                <Typography variant="subtitle2" sx={{ color: '#555' }}>
                  {t('general.subject')}
                </Typography>
              </Grid>
              <Grid item>
                <Box display="flex" alignItems="flex-end">
                  {extendResponse?.subject}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </DialogContent>
      )}
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(EmailTemplatePreviewDialog)
